import CheckboxControl from './checkbox-control';

export default CheckboxControl;